export default {"src":"/_next/static/media/favorites-filled-annsacks.10cdd75e.svg","height":14,"width":15};